<template>
  <v-layout column>
    <v-flex>
      <lookup-select
        label="Accreditation Type"
        v-model="item.accreditationtypeid"
        lookup-name="AccreditationTypes"
      />
    </v-flex>
    <v-flex>
       <v-text-field
            type="number"
            v-model="item.accreditationyear"
            label="Accreditation Year"
          />
    </v-flex>    
  </v-layout>
</template>

<script>
export default {
  name: "AccreditationForm",
  props: {
    item: Object,
    required: true
  },
  created() {
    // this.item.verificationrequestdate =
    //   this.item.verificationrequestdate || new Date();

    // this.item.registrationyear =
    //   this.item.registrationyear || this.$moment().format("YYYY");
  }
};
</script>
